import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Send } from 'lucide-react';
export function Contact() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    setFormStatus('submitting');
    try {
      const formData = new FormData(form);
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      });
      const data = await response.json();
      if (data.success) {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 4000);
      } else {
        setFormStatus('error');
        setTimeout(() => setFormStatus('idle'), 4000);
      }
    } catch {
      setFormStatus('error');
      setTimeout(() => setFormStatus('idle'), 4000);
    }
  };
  return <section id="contact" className="py-24 bg-[#0A0A0F] relative" data-id="element-51">
      {/* Background Glow */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-blue-600/10 rounded-full blur-[120px] pointer-events-none" data-id="element-52"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-53">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-54">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-55">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-56">
              Let's Build Something{' '}
              <span className="text-gradient" data-id="element-57">Amazing</span>
            </h2>
            <p className="text-lg mb-10 text-[#FFFFFF]" data-id="element-58">
              Ready to elevate your online presence? Fill out the form or reach
              out directly. I usually respond within a few hours.
            </p>

            <div className="space-y-8 mb-12" data-id="element-59">
              <a href="tel:818-381-9905" className="flex items-center gap-6 group" data-id="element-60">
                <div className="w-14 h-14 rounded-2xl bg-blue-500/10 flex items-center justify-center text-blue-400 group-hover:bg-blue-600 group-hover:text-white transition-all border border-blue-500/20" data-id="element-61">
                  <Phone size={24} data-id="element-62" />
                </div>
                <div data-id="element-63">
                  <p className="text-slate-500 text-sm mb-1" data-id="element-64">
                    Call Me Directly
                  </p>
                  <p className="text-xl font-bold text-white" data-id="element-65">818-381-9905</p>
                </div>
              </a>

              <a href="mailto:mikesproweb@gmail.com" className="flex items-center gap-6 group" data-id="element-66">
                <div className="w-14 h-14 rounded-2xl bg-blue-500/10 flex items-center justify-center text-blue-400 group-hover:bg-blue-600 group-hover:text-white transition-all border border-blue-500/20" data-id="element-67">
                  <Mail size={24} data-id="element-68" />
                </div>
                <div data-id="element-69">
                  <p className="text-slate-500 text-sm mb-1" data-id="element-70">Email Me</p>
                  <p className="text-xl font-bold text-white" data-id="element-71">
                    mikesproweb@gmail.com
                  </p>
                </div>
              </a>

              <div className="flex items-center gap-6" data-id="element-72">
                
                <div data-id="element-73">
                  
                  
                </div>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-74">
              <a href="tel:818-381-9905" className="px-6 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition-colors shadow-md" data-id="element-75">
                Call Now
              </a>
              <a href="mailto:mikesproweb@gmail.com" className="px-6 py-3 rounded-lg bg-white/5 hover:bg-white/10 text-white border border-white/10 font-medium transition-colors" data-id="element-76">
                Send Email
              </a>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-[#111118] border border-white/5 rounded-3xl p-8 md:p-10 shadow-2xl" data-id="element-77">
            <h3 className="text-2xl font-bold text-white mb-6" data-id="element-78">
              Request a Free Consultation
            </h3>

            <form onSubmit={handleSubmit} className="space-y-5" data-id="element-79">
              <input type="hidden" name="access_key" value="c10950f6-01a1-4871-8cc0-569baf2fe57f" data-id="element-80" />
              <input type="hidden" name="subject" value="New Website Inquiry from Mike's Pro Web Design" data-id="element-81" />
              <input type="hidden" name="from_name" value="Mike's Pro Web Design" data-id="element-82" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-83">
                <div data-id="element-84">
                  <label htmlFor="contact-name" className="block text-sm font-medium mb-2 text-[#FFFFFF]" data-id="element-85">
                    Full Name
                  </label>
                  <input id="contact-name" type="text" name="name" required className="w-full bg-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all" placeholder="John Doe" data-id="element-86" />
                </div>
                <div data-id="element-87">
                  <label htmlFor="contact-email" className="block text-sm font-medium mb-2 text-[#FFFFFF]" data-id="element-88">
                    Email Address
                  </label>
                  <input id="contact-email" type="email" name="email" required className="w-full bg-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all" placeholder="john@example.com" data-id="element-89" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-90">
                <div data-id="element-91">
                  <label htmlFor="contact-phone" className="block text-sm font-medium mb-2 text-[#FFFFFF]" data-id="element-92">
                    Phone Number
                  </label>
                  <input id="contact-phone" type="tel" name="phone" className="w-full bg-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all" placeholder="(555) 123-4567" data-id="element-93" />
                </div>
                <div data-id="element-94">
                  <label htmlFor="contact-business" className="block text-sm font-medium mb-2 text-[#FFFFFF]" data-id="element-95">
                    Business Name
                  </label>
                  <input id="contact-business" type="text" name="business" className="w-full bg-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all" placeholder="Your Company LLC" data-id="element-96" />
                </div>
              </div>

              <div data-id="element-97">
                <label htmlFor="contact-message" className="block text-sm font-medium mb-2 text-[#FFFFFF]" data-id="element-98">
                  Project Details
                </label>
                <textarea id="contact-message" name="message" required rows={4} className="w-full bg-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all resize-none" placeholder="Tell me about your business and what you're looking to build..." data-id="element-99"></textarea>
              </div>

              <button type="submit" disabled={formStatus === 'submitting'} className="w-full py-4 rounded-lg bg-gradient-to-r from-blue-600 to-blue-500 text-white font-bold text-lg hover:shadow-[0_0_20px_rgba(59,130,246,0.3)] transition-all flex items-center justify-center gap-2 disabled:opacity-70" data-id="element-100">
                {(formStatus === 'idle' || formStatus === 'error') && <>
                    Get My Free Quote <Send size={20} data-id="element-101" />
                  </>}
                {formStatus === 'submitting' && 'Sending...'}
                {formStatus === 'success' && 'Message Sent!'}
              </button>

              {formStatus === 'success' && <p className="text-sm text-green-400 text-center" role="status" data-id="element-102">
                  Thanks! Your message has been sent — I'll be in touch shortly.
                </p>}
              {formStatus === 'error' && <p className="text-sm text-red-400 text-center" role="alert" data-id="element-103">
                  Something went wrong. Please try again or email me directly.
                </p>}
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}